import React, { Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { Loader, Link } from '@jutro/components';
//import { renderContentFromMetadata } from '@jutro/uiconfig';
import { MetadataContent } from '@jutro/uiconfig';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Currency as CurrencyField } from 'gw-components-platform-react';
//import { Link as LinkComponent, Currency as CurrencyField } from 'gw-components-platform-react';
//import { policyCommissionMessages } from 'gw-capability-gateway-commission-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { JobUtil } from 'gw-portals-util-js';
import { GatewayPolicyService} from 'gw-capability-ri-policy';
import policyTermsStyles from '../Terms/PolicyTerms.module.scss';
import metadata from './LossRuns.metadata.json5';
import messages from '../Terms/PolicyTerms.messages';
import { GatewayDocumentService } from 'gw-capability-gateway-document';

class LossRun extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                    account: PropTypes.shape({
                        accountNumber: PropTypes.string
                    })
                })
            }),
            billingData: PropTypes.shape({})
        }).isRequired,
        intl: PropTypes.func.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired
    };

    state = {
        policyTermsData: [],
        isPolicyTermsAvailable: true,
        isLoading: true,
        selectedPolicies: [],    
        lossRunsDocLink: ''
    };

    componentDidMount = () => {
        this.getPolicyTermsInfo();
    };

    
    getPolicyTermsInfo = async () => {
        const { authHeader, fromAccountLanding } = this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );        
        const policyTermsResponse = await GatewayPolicyService.getPolicyTermsForPolicy_Ext(
            policyNumber,'LossRuns',
            authHeader
        );    
        if (!_.isEmpty(policyTermsResponse) && policyTermsResponse.length > 0) {
            const policyTermsDataTable = this.getPolicyTermsDataTable(policyTermsResponse);            
            this.setState({
                policyTermsData: policyTermsDataTable, 
                isLoading: false,
                lossRunsDocLink: this.getLossRunsDownloadLink(policyTermsResponse[0].docSessionID)
            });
        } else {
            this.setState({ isPolicyTermsAvailable: false, isLoading: false});
        }
    };

    getPolicyTermsDataTable = (policyTermsResponse) => {
        // console.log(`policyTermsResponse = ${JSON.stringify(policyTermsResponse)}`);
        let invoiceArrayResult = [];
        invoiceArrayResult = policyTermsResponse.map((data) => {
            const objData = {
                policyNbr: data.policyNumber,
                policyTerm: this.getFormattedDate(data.effective) + " - " +  this.getFormattedDate(data.expiration),
                state: data.primaryState_Ext,
                totalClaims: data.totalClaims_Ext,
                incurredLoss: data.totalIncurred_Ext,
                isPCPolicyTerm: data.isPcPolicyTerm_Ext
            };
            return objData;
        });
        return invoiceArrayResult;
    };

    getPolicyLink = (item, index, property) => {
        const toolTipMessage = {
        //     policyNumber: translator(claimsMessages.policyNumberClaimDetail),
        //     claimNumber: translator(claimsMessages.claimNumber)
        };
        if (property.id === 'policyNbr' && item.isPCPolicyTerm) {
            const redirectRoute = `/ri-policies/${item.policyNbr}/summary`
            const redirectPath = {
                pathname: redirectRoute,
                state: {
                    policyNumber: item[property.id],
                    redirectPath: '/ri-policies',
                }
            };
            return (
                <Link
                    to={redirectPath}
                    className={policyTermsStyles.gwClaimsLinkContent}
                    title={toolTipMessage[property.id]}
                >
                    {item[property.id]}
                </Link>
            );    
        } else {
            return item[property.id]

        }
    };

    getCell = (items, index, property) => {
        const translator = this.context;
        const tooltipMessage = {
            dueDate: translator(messages.dueDateLabel),
            paidStatus: translator(messages.paidStatusLabel)
        };

        let showPastDueAlert = false;
        if (
            moment().isAfter(items.dueDate)
            && items.outStanding.amount > 0
            && property.id === 'paidStatus'
        ) {
            // eslint-disable-next-line no-param-reassign
            items.paidStatus = translator(messages.pastDue);
            showPastDueAlert = true;
        }

        const classNameShowPastDueAlert = classNames({
            [policyTermsStyles.negativePastDueAlert]: showPastDueAlert
        });

        return (
            <span title={tooltipMessage[property.id]} className={classNameShowPastDueAlert}>
                {items[property.id]}
            </span>
        );
    };

    getFormattedCurrency = (item, index, property) => {
        const translator = this.context;
        const tooltipMessage = {
            paid: translator(messages.PaidLabel),
            outStanding: translator(messages.outstandingLabel),
            statementAmount: translator(messages.statementAmountLabel)
        };

        return (
            <span
                title={tooltipMessage[property.id]}
                className={policyTermsStyles.riCurrencyField}
            >
                <CurrencyField
                    id={`currency_${index}`}
                    value={item[property.id]}
                    readOnly
                    hideLabel
                    showOptional={false}
                />
            </span>
        );
    };

    getFormattedDate = (date) => {
        const { intl } = this.props;
        return intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
    };

    getCounterField = (item, index, property) => {
        return (
            <span                
                className={policyTermsStyles.riCurrencyField}
            >
                {item[property.id]}             
            </span>
        );
    }
    handlePolicyChange = (items) => {
        this.setState({
            selectedPolicies: items
        });
    };  

    generateReportPDF = () => {
        let { selectedPolicies, lossRunsDocLink } = this.state;
        //vp::: Alert as pdf placeholder to do
        if (!(_.isEmpty(selectedPolicies))) {
            // Call service to generate PDF            
            lossRunsDocLink += `&lossRunDoc=true&policyNumber=${selectedPolicies}`;            
            window.open(lossRunsDocLink, '_blank');
        } else {
            alert("Select a policy to generate PDF");
        }

    };  
    
    getLossRunsDownloadLink = (sessionID) => {
        const publicID = 'pclr:0000';
        return GatewayDocumentService.downloadDocument(publicID, sessionID);
    };

    render() {
        const {
            policyTermsData,            
            isPolicyTermsAvailable,
            isLoading,
            selectedPolicies     
        } = this.state;
        const translator = this.context;

        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }        

        const overrides = {
            policyTermsTable: {
                data: policyTermsData
            },
            policyTermsContainer: {
                visible: isPolicyTermsAvailable
            },
            disableGeneratePDF: {
                 value: !(_.isEmpty(selectedPolicies))
             },
            downloadPDFHeader: {
                disabled: (_.isEmpty(selectedPolicies))
            },
            policyEmptyContainer: {
                visible: !isPolicyTermsAvailable
            },
            warningMessage: {
                value: translator(messages.noBillingDataLabel)
            }
        };

        const resolvers = {
            resolveClassNameMap: policyTermsStyles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getPolicyLink: this.getPolicyLink,
                getFormattedCurrency: this.getFormattedCurrency,
                handlePolicyChange: this.handlePolicyChange,
                handleButtonClick: this.generateReportPDF,
                getCounterField: this.getCounterField
            }
        };

        //const policyPage = renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
        const policyPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
        return <div className={policyTermsStyles.policyterms}>{policyPage}</div>;
    }
}

export const LossRunComponent = LossRun;
export default withIntl(withAuthenticationContext(LossRun));
